<template>
    <v-dialog
        v-model="showDialog"
        v-if="showDialog"
        lazy
        absolute
        persistent
        content-class="post-actions">
        <v-card>
            <v-flex tag="h6"> {{title}}
                <v-btn icon data-qe-id="dialogCloseIcon" @click="closeAction">
                    <v-icon size="20">close</v-icon>
                </v-btn>
            </v-flex>
            <v-flex tag="p" v-html="message"></v-flex>
            <v-flex :class="isNoButtonRequired ? 'text-xs-right' : 'text-xs-center'">
                <status-bar :action="actionName"></status-bar>
                <v-btn flat @click="noAction"
                    data-qe-id="dialogCloseBtn"
                    v-if="isNoButtonRequired"
                    class="primary_btn transparent">
                    {{noText}}
                </v-btn>
                <v-btn dark @click="yesAction" data-qe-id="dialogConfirmBtn" class="primary_btn">
                    {{yesText}}
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>
<script>
import { memberProfileConstants } from '../memberProfile.constants';
import StatusBar from "../../StatusBar/StatusBar";

export default {
    name: 'ConfirmationDialog',
    data: () => ({
            memberProfileConstants,
        }),
    components: {
        StatusBar,
    },
    props: {
        value: {
            type: Boolean,
        },
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            required: true,
        },
        actionName: {
            type: Object,
        },
        yesText: {
            type: String,
            default: 'Yes',
        },
        noText: {
            type: String,
            default: 'No',
        },
        yesFunction: {
            type: Function,
        },
        noFunction: {
            type: Function,
        },
        closeFunction: {
            type: Function,
        },
        typeOfDialog: {
            type: String,
            required: true,
        },
    },
    methods: {
        closeAction() {
            if (this.closeFunction) {
                this.closeFunction();
            } else {
                this.showDialog = false;
            }
        },
        yesAction() {
            if (this.yesFunction) {
                this.yesFunction();
            } else {
                this.showDialog = false;
            }
        },
        noAction() {
            if (this.noFunction) {
                this.noFunction();
            } else {
                this.showDialog = false;
            }
        },
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isNoButtonRequired() {
            return this.typeOfDialog.toLowerCase() === memberProfileConstants.CONFIRM;
        },
    },
};
</script>
